// Copyright (c) 2022 Enabler Interactive Pty Ltd

import config from '../config/config.json'
import dateFormat from "dateformat";

/**
 * Basic email format validation. Returns true if valid; false otherwise.
 */
export function validateEmail(email) {
    var emailPattern = /^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
}

/**
 * Convert a JSON error array (can contain more than one error) to a printable string - remove and replace JSON-specific tokens.
 */
export function printableJsonError(responseJson) {
    if (responseJson) {
        return JSON.stringify(responseJson).replace(/[{}\[\]"]/g, "").replace(/:/g, " ").replace(/,/g, ", ")
    } else {
        return "Error"
    }
}

/**
 * Custom format for date as dd/mm/yyyy.
 */
export function evalDateDay(date) {
    if (date == null) {
        return
    } else {
        return dateFormat(new Date(date), "dd/mm/yyyy")
    }
}

/**
 * Custom format for date as dd/mm/yyyy HH/mm.
 */
export function evalDateHour(date) {
    if (date == null)
        return

    date = new Date(date)

    let tempDate = ''

    if (date.getDate() < 10) {
        tempDate += '0'
    }

    tempDate += date.getDate() + '/'

    if ((date.getMonth() + 1) < 10) {
        tempDate += '0'
    }

    tempDate += (date.getMonth() + 1) + '/'

    if (date.getFullYear() < 10) {
        tempDate += '0'
    }

    tempDate += date.getFullYear() + ' '

    if (date.getHours() < 10) {
        tempDate += '0'
    }

    tempDate += date.getHours() + ':'

    if (date.getMinutes() < 10) {
        tempDate += '0'
    }

    tempDate += date.getMinutes()

    return tempDate
}

/** 
 * Evalutate worker's progress/rating for a module. Passing null strikes means there are no results yet.
 */
export function evalRatingModule(completed, average_strikes) {
    if (completed === true) {
        switch (Math.round(average_strikes)) {
            case 0: return 'Excellent'
            case 1: return 'Good'
            case 2: return 'Pass'
            case 3: return 'Poor'
            default: return 'Not Started'
        }
    } else {
        if (average_strikes === null) {
            return "Not Started"
        } else {
            return "In Progress"
        }
    }
}

/**
 * Evaluate the style class for a rating.
 */
export function evalRatingClass(rating) {
    return rating.toLowerCase().replace('/\s/g', '')
}

/**
 * Bootstrap Modal 0.33 has a bug where it does not remove the 'modal-open' class or style 'overflow' tag after closing the modal menu,
 * leaving the website's global scrollbar turned off. This needs to be manually fixed to turn the scrollbar back on, so the user
 * doesn't have to refresh the page to fix it.
 */
export function fixScrollbar() {
    document.body.classList.remove('modal-open')
    document.body.style = null
    document.body.removeAttribute("class")
    document.body.removeAttribute("style")
}

/**
 * Get a module's categories as a cleanly formatted string, with any Exclusive organisation names removed.
 */
export function getCategoriesString(categories) {
    if (categories.includes(config.consts.MOD_EXCLUSIVE)) {
        let startOrgNames = categories.indexOf('(')
        let endOrgNames = categories.indexOf(')')
        let orgNames = categories.substring(startOrgNames + 1, endOrgNames)
        // Remove brackets and org names from displaying in the Categories field
        let cleanCategories = categories.replace("(" + orgNames + ")", "")
        // Perform whitespace cleanup
        let categoriesArr = cleanCategories.trim().split(',')
        cleanCategories = categoriesArr.toString()

        return cleanCategories
    }
    else {
        return categories
    }
}

/**
 * Get an array containing the Exclusive organisation names in a module's categories.
 */
export function getCategoriesOrgs(categories) {
    if (categories.includes(config.consts.MOD_EXCLUSIVE)) {
        let startOrgNames = categories.indexOf('(')
        let endOrgNames = categories.indexOf(')')
        let orgNames = categories.substring(startOrgNames + 1, endOrgNames)
        // Convert to array and trim whitespace on each element
        let orgNamesArr = orgNames.split(',').map(org => org.trim())

        return orgNamesArr
    }
    else {
        return []
    }
}


// WEBPACK FOOTER //
// ./src/utils/enUtils.js